/**
 * DB 기반 블로그 API 클라이언트 (배포 없이 발행되는 글).
 * 기존 TS 번들 글(getPosts/getPost)과 하이브리드로 합쳐서 사용한다.
 * DB 글이 같은 slug 면 DB 글이 우선(최신 발행 반영).
 */
import { api } from '../../lib/api'
import type { BlogPost } from './blogData'

// API 응답(snake_case) → BlogPost(camelCase) 매핑
interface ApiListItem {
  slug: string; lang: 'ko' | 'en'; category: string; title: string
  standfirst: string; cover: string | null; read_min: number
  featured: boolean; hide_date: boolean; post_date: string | null
}
interface ApiPost extends ApiListItem { blocks: BlogPost['blocks'] }

function toPost(a: ApiPost): BlogPost {
  return {
    slug: a.slug, lang: a.lang, category: a.category, title: a.title,
    standfirst: a.standfirst, cover: a.cover ?? '', readMin: a.read_min,
    featured: a.featured, hideDate: a.hide_date, date: a.post_date ?? '',
    blocks: a.blocks ?? [],
  }
}
function toListPost(a: ApiListItem): BlogPost {
  return { ...toPost({ ...a, blocks: [] }) }
}

export async function fetchDbPosts(lang: 'ko' | 'en'): Promise<BlogPost[]> {
  try {
    const { data } = await api.get<ApiListItem[]>('/blog', { params: { lang } })
    return data.map(toListPost)
  } catch {
    return []  // API 실패 시 TS 글만 노출 (graceful degrade)
  }
}

export async function fetchDbPost(slug: string, lang: 'ko' | 'en'): Promise<BlogPost | null> {
  try {
    const { data } = await api.get<ApiPost>(`/blog/${slug}`, { params: { lang } })
    return toPost(data)
  } catch {
    return null
  }
}
